function roundToDecimalPlace(number, decimalPlaces) {
  const factor = Math.pow(10, decimalPlaces);
  return Math.round(number * factor) / factor;
}

const projectMap = {
  1: {
    name: '血糖血脂',
    projectItem: {
      result_0: {
        name: 'GLU',
        chineseName: '葡萄糖',
        unit: 'mmol/L',
        range: '3.9-6.1',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.01, 1);
        }
      },
      result_1: {
        name: 'TG',
        chineseName: '甘油三酯',
        unit: 'mmol/L',
        range: '<1.7',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.001, 2);
        }
      },
      result_2: {
        name: 'HDL-C',
        chineseName: '高密度脂蛋白胆固醇',
        unit: 'mmol/L',
        range: '>1',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.001, 2);
        }
      },
      result_3: {
        name: 'TC',
        chineseName: '总胆固醇',
        unit: 'mmol/L',
        range: '<5.2',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.001, 2);
        }
      },
      result_4: {
        name: 'LDL-C',
        chineseName: '低密度脂蛋白胆固醇',
        unit: 'mmol/L',
        range: '<3.4',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.001, 2);
        }
      }
    }
  },
  9: {
    name: '肝功 3 项',
    projectItem: {
      result_0: {
        name: 'ALT',
        chineseName: '谷丙转氨酶',
        unit: 'U/L',
        range: '10-50',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.1, 0);
        }
      },
      result_1: {
        name: 'AST',
        chineseName: '谷草转氨酶',
        unit: 'U/L',
        range: '13-40',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.1, 0);
        }
      },
      result_2: {
        name: 'ALB',
        chineseName: '白蛋白',
        unit: 'g/L',
        range: '40-55',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.01, 1);
        }
      }
    }
  },
  3: {
    name: '肾功 3 项',
    projectItem: {
      result_0: {
        name: 'CR',
        chineseName: '肌酐',
        unit: 'umol/L',
        range: '41-111',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.1, 0);
        }
      },
      result_1: {
        name: 'UA',
        chineseName: '尿酸',
        unit: 'umol/L',
        range: '155-428',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.1, 0);
        }
      },
      result_2: {
        name: 'UREA',
        chineseName: '尿素',
        unit: 'mmol/L',
        range: '2.6-9.5',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.01, 1);
        }
      },
      result_3: {
        name: 'BUN/CR',
        chineseName: '尿素氮/肌酐',
        unit: '',
        range: '',
        calc: function(n) {
          return roundToDecimalPlace(n / 100, 1);
        }
      },
      result_4: {
        name: 'UREA/CR',
        chineseName: '尿素/肌酐',
        unit: '',
        range: '',
        calc: function(n) {
          return roundToDecimalPlace(n / 10000, 2);
        }
      }
    }
  },
  7: {
    name: '代谢 3 项',
    projectItem: {
      result_0: {
        name: 'GLU',
        chineseName: '葡萄糖',
        unit: 'mmol/L',
        range: '3.9-6.1',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.01, 1);
        }
      },
      result_1: {
        name: 'UA',
        chineseName: '尿酸',
        unit: 'umol/L',
        range: '155-428',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.1, 0);
        }
      },
      result_2: {
        name: 'TC',
        chineseName: '总胆固醇',
        unit: 'mmol/L',
        range: '<5.2',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.001, 2);
        }
      }
    }
  },
  6: {
    name: '献血 2 项',
    projectItem: {
      result_0: {
        name: 'ALT',
        chineseName: '谷丙转氨酶',
        unit: 'U/L',
        range: '10-50',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.1, 0);
        }
      },
      result_1: {
        name: 'HB',
        chineseName: '血红蛋白',
        unit: 'g/L',
        range: '110-160',
        calc: function(n) {
          return roundToDecimalPlace(n * 0.1, 0);
        }
      }
    }
  }
};

export default function(e) {
  const dataValue = JSON.parse(JSON.parse(e.dataValue));
  console.log(dataValue);
  const projectItem = projectMap[dataValue.apiMode].projectItem;
  e.checkReportInspectionList = Object.keys(projectItem).map(i => {
    return {
      unit: projectItem[i].unit,
      paramValue: projectItem[i].calc(dataValue[i]),
      paramName: projectItem[i].name + projectItem[i].chineseName,
      range: projectItem[i].range
    };
  });
  e.showRange = true;
}
